// extracted by mini-css-extract-plugin
module.exports = {"copyright":"FooterNavigationGroup_copyright__t5xXW","copyrightLinks":"FooterNavigationGroup_copyrightLinks__0gl3P","copyrightText":"FooterNavigationGroup_copyrightText__NdeXX"};